import styled from '@emotion/styled';
import { boxSizes, colors, colorVariables, fontWeights, gutterSizes } from '@gumtree/ui-library/src/base/theme';

export const DescribeFormContainer = styled.div`
    height: calc(100% - 48px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const DescribeFormContent = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 0 ${gutterSizes.large};

    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE & Edge */

    &::-webkit-scrollbar {
        display: none;
    }

    & > h2 {
        margin-bottom: ${gutterSizes.base};
    }
`;

export const DescribeContent = styled.div`
    margin-bottom: ${gutterSizes.xlarge};
`;

export const DescribeFormButtons = styled.div`
    border-top: 1px solid ${colorVariables.borderLight};
    padding: ${gutterSizes.large};
    display: flex;
    gap: ${gutterSizes.base};

    button {
        flex: 1;
        height: ${boxSizes.boxHeight48};
        font-weight: ${fontWeights.bold};
        border-radius: ${boxSizes.borderRadius};
        transition: background-color 0.3s ease;

        &:hover {
            opacity: 0.9;
        }
    }
`;

export const NextButton = styled.button`
    background-color: ${colors.gtGreen};
    border: none;
    color: ${colorVariables.textHighlightedDescription};
    cursor: pointer;
`

export const BackButton = styled.button`
    background-color: ${colors.white};
    border: 1px solid ${colorVariables.textHighlightedDescription};
    color: ${colorVariables.textHighlightedDescription};
    cursor: pointer;
`
